import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "authentication-modal",
  tabindex: "-1",
  "aria-hidden": "true",
  class: "fixed top-0 left-0 right-0 z-50 flex justify-center items-center w-full p-4 overflow-x-hidden shadow-lg bg-gray-700 bg-opacity-50 overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"
}
const _hoisted_2 = { class: "relative w-full max-w-md max-h-full" }
const _hoisted_3 = { class: "relative bg-white rounded-lg shadow dark:bg-gray-700" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "px-6 py-6 lg:px-8" }
const _hoisted_8 = { class: "mb-4 text-left text-xl font-medium text-gray-900 dark:text-white" }
const _hoisted_9 = {
  class: "space-y-6",
  action: "#"
}
const _hoisted_10 = {
  for: "category",
  class: "text-left block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "pb-6 text-center" }

import { computed  } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryModal',
  props: {
    typeOfCategory: String,
    label: String,
    placeholder: String
},
  setup(__props, { emit: emits }) {




let enteredCategory = '';

const isEnteredCategoryEmpty = computed(() => enteredCategory.trim().length === 0);

const addCategory = () => {
    emits('addCategory', enteredCategory);
    enteredCategory = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeCategoryModal'))),
          type: "button",
          class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
        }, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.typeOfCategory), 1),
          _createElementVNode("form", _hoisted_9, [
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(__props.label), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(enteredCategory) ? (enteredCategory).value = $event : enteredCategory = $event)),
                name: "category",
                id: "category",
                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-button-bg focus:border-button-bg block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white",
                placeholder: __props.placeholder,
                required: ""
              }, null, 8, _hoisted_11), [
                [_vModelText, _unref(enteredCategory)]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: addCategory,
            type: "button",
            class: "text-white w-fit bg-button-bg hover:bg-button-bg-hover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex justify-center items-center disabled:opacity-50"
          }, " Add Category "),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeCategoryModal'))),
            type: "button",
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
          }, "No, cancel")
        ])
      ])
    ])
  ]))
}
}

})